export default __webpack_public_path__ + "static/media/Leaders_IMG-Jeremiah.e6391d58.png";